<template>
  <div class="card">
    <div class="card-body">
      <div class="card-title">
        <h2>
          클래스 추가
        </h2>
        <p class="gray">클래스를 추가합니다.</p>
      </div>
    </div>

    <el-form :model="frm" :rules="rules" status-icon ref="frm" label-width="120px" class="demo-form">
      <div class="card-body gray">
        <div class="card-form textarea">
          <el-form-item label="클래스 이름" prop="class_name">
            <el-input v-model="frm.class_name" placeholder="클래스 이름을 입력하십시오."></el-input>
          </el-form-item>
          <el-form-item label="수강 과목" prop="cate_code">
            <el-select v-model="frm.cate_code" placeholder="선택하세요.">
              <el-option v-for="item in categoryList" :key="item.lvl_1_code" :label="item.lvl_1_name" :value="item.lvl_1_code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="담당 선생님" prop="class_manager">
            <el-select v-model="frm.class_manager" placeholder="선택하세요.">
              <el-option v-for="item in managerList" :key="item.user_info_seq" :label="item.name" :value="item.user_info_seq">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="비고" prop="memo">
            <el-input type="textarea" :rows="2" v-model="frm.memo" placeholder="비고를 입력하십시오."></el-input>
          </el-form-item>
          <el-form-item label="클래스 사용">
            <el-switch v-model="isUse" active-text="" inactive-text=""></el-switch>
          </el-form-item>
          <el-form-item label="가입요청">
            <el-switch v-model="isUseReg" active-text="" inactive-text=""></el-switch>
          </el-form-item>
          <el-form-item label="출석관리">
            <el-switch v-model="isUseAttend" active-text="" inactive-text=""></el-switch>
          </el-form-item>
          <el-form-item label="온라인시험">
            <el-switch v-model="isUseOnline" active-text="" inactive-text=""></el-switch>
          </el-form-item>
        </div>
      </div>

      <div class="card-body text-right">
        <el-button type="default" @click="resetForm('frm')">취소</el-button>
        <el-button type="danger" @click="deleteClass" v-if="frm.class_seq !== 0">삭제</el-button>
        <el-button type="primary" @click="submitForm('frm')">저장</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M020102',
  mixins: [common.mixins],
  data () {
    return {
      isUse: true,
      isUseReg: true,
      isUseAttend: false,
      isUseOnline: false,
      isModify: true,
      frm: {
        class_seq: 0,
        cate_code: '',
        class_name: '',
        class_manager: '',
        memo: '',
        use_yn: 'Y',
        use_reg_yn: 'Y',
        attend_yn: 'N',
        online_yn: 'N'
      },
      categoryList: [],
      managerList: [],
      selectedOptions: [],
      options: [],
      rules: {
        class_name: [
          { required: true, message: '클래스 이름을 입력하십시오.', trigger: 'blur' },
          { min: 3, max: 20, message: '최소 3자 이상 최대 20자까지 입력하십시오.' }
        ],
        cate_code: [
          { required: true, message: '카테고리를 선택하십시오.', trigger: 'change' }
        ],
        class_manager: [
          { required: false, message: '담당을 선택하십시오.', trigger: 'change' }
        ],
        memo: [
          { required: false, message: '내용을 입력하십시오.', trigger: 'blur' }
        ]
      }
    }
  },
  beforeCreate () {
  },
  created () {
    Promise.all([
      common.axios.post('/category/list', {level: 1}), // 수강과목
      common.axios.get('/user/list/manager') // 강사
    ]).then(response => {
      this.categoryList = response[0].data
      this.managerList = response[1].data
      // 조회
      const classSeq = this.$route.params.class_seq
      if (classSeq && classSeq !== 0) {
        this.loadInfo(classSeq)
      }
    })
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const isInsert = this.frm.class_seq === 0
          const config = {
            url: isInsert ? '/class/storage' : '/class',
            method: isInsert ? 'post' : 'put',
            data: this.frm
          }
          common.axios.request(config)
            .then(response => {
              if (response.data.status === 1) {
                if (isInsert) {
                  this.$message('등록하였습니다.')
                } else {
                  this.$message('수정하였습니다.')
                }
                setTimeout(() => {
                  this.movePage()
                }, 1000)
              }
            })
        } else {
          this.$message.error('등록 내용을 확인하십시오.')
        }
      })
    },
    resetForm (formName) {
      // this.$refs[formName].resetFields()
      // this.clearForm()
      this.movePage()
    },
    movePage () {
      if (this.$route.params.return_page) {
        this.$router.push({name: this.$route.params.return_page, params: {class_seq: this.frm.class_seq}})
      } else {
        this.$router.push({name: 'M020101'})
      }
    },
    clearForm () {
      this.frm.class_seq = 0
      this.isUse = true
    },
    loadInfo (classSeq) {
      common.axios.get('/class/load/' + classSeq)
        .then(response => {
          const result = response.data
          Object.keys(this.frm).forEach(key => {
            this.frm[key] = this.isEmpty(result.class[key]) ? '' : result.class[key]
          })
          this.isUse = result.class.use_yn === 'Y'
          this.isUseReg = result.class.use_reg_yn === 'Y'
          this.isUseAttend = result.class.attend_yn === 'Y'
          this.isUseOnline = result.class.online_yn === 'Y'
        })
    },
    deleteClass () {
      this.$confirm('해당 클래스를 삭제하시겠습니까?', '', {
      }).then(() => {
        common.axios.delete('/class', {data: {class_seq: this.frm.class_seq}})
          .then(response => {
            if (response.data.status === 1) {
              this.$message('삭제되었습니다.')
              setTimeout(() => {
                this.$router.push({name: 'M020101'})
              }, 1000)
            } else {
              this.$message.warning(response.data.message)
            }
          })
          .catch(() => {
            this.$message.error('삭제 실패하였습니다. 관리자에게 문의하세요')
          })
      }).catch(() => {
      })
    }
  },
  watch: {
    isUse: function (value) {
      this.frm.use_yn = value ? 'Y' : 'N'
    },
    isUseReg: function (value) {
      this.frm.use_reg_yn = value ? 'Y' : 'N'
    },
    isUseAttend: function (value) {
      this.frm.attend_yn = value ? 'Y' : 'N'
    },
    isUseOnline: function (value) {
      this.frm.online_yn = value ? 'Y' : 'N'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/M020102.vue